import * as _ from 'underscore';
import { ErrorReason } from '../../sessionManagement/SessionManagementService';
import { GetExtractEncryptionStatsRequest, IGetExtractEncryptionStatsParams, IGetExtractEncryptionStatsResult } from '../../ts/ServerApi/requests/GetExtractEncryptionStatsRequest';
import { RequestPoller } from './RequestPoller';

let statusPoller: RequestPoller<IGetExtractEncryptionStatsParams, IGetExtractEncryptionStatsResult>;

function pollExtractEncryptionStats(
  siteId: string,
  notifyCallback?: (result: IGetExtractEncryptionStatsResult) => void
): Promise<IGetExtractEncryptionStatsResult> {
  const request = new GetExtractEncryptionStatsRequest({id: siteId});

  const isComplete = (result: IGetExtractEncryptionStatsResult): boolean => {
    return result && result.counts && result.counts.encrypting === 0 && result.counts.decrypting === 0;
  };

  return new Promise((resolve, reject) => {
    statusPoller = new RequestPoller(
      request,
      isComplete,
      (result: IGetExtractEncryptionStatsResult) => resolve(result), // success callback
      (reason: ErrorReason) => reject(reason), // failure callback,
      notifyCallback,
    );
    statusPoller.startPolling();
  });
}

function cancelExtractEncryptionStatsPolling() {
  statusPoller?.cancelPolling();
}

export const ExtractEncryptionService = {
  pollExtractEncryptionStats,
  cancelExtractEncryptionStatsPolling
};

export type ExtractEncryptionService = typeof ExtractEncryptionService;
